import type { ConsultantDashboardView } from '@travel-planner/shared/schemas/consultant-dashboard';
import { validateSalesGoalsSearch } from '@dashboard/features/sales-goals-filters';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { CONSULTANT_DASHBOARD_VIEW } from '@travel-planner/shared/schemas/consultant-dashboard';
import { protectedRoute } from './_root';

// ─── Inline validateSearch for Consultant Dashboard ──────────────

type ConsultantDashboardSearch = {
  view?: ConsultantDashboardView;
  year?: number;
  quarter?: number;
  consultantId?: string;
  countryId?: string;
  teamId?: string;
  isTesting?: boolean;
};

const CONSULTANT_DASHBOARD_VIEW_VALUES = Object.values(
  CONSULTANT_DASHBOARD_VIEW
) as ReadonlyArray<string>;

const validateConsultantDashboardSearch = (
  input: Record<string, unknown>
): ConsultantDashboardSearch => ({
  view:
    typeof input.view === 'string' &&
    CONSULTANT_DASHBOARD_VIEW_VALUES.includes(input.view)
      ? (input.view as ConsultantDashboardView)
      : undefined,
  year:
    typeof input.year === 'number' && Number.isInteger(input.year)
      ? input.year
      : undefined,
  quarter:
    typeof input.quarter === 'number' &&
    Number.isInteger(input.quarter) &&
    input.quarter >= 1 &&
    input.quarter <= 4
      ? input.quarter
      : undefined,
  consultantId:
    typeof input.consultantId === 'string' ? input.consultantId : undefined,
  countryId: typeof input.countryId === 'string' ? input.countryId : undefined,
  teamId: typeof input.teamId === 'string' ? input.teamId : undefined,
  isTesting:
    input.isTesting === true || input.isTesting === 'true' ? true : undefined,
});

export const consultantDashboardRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'dashboard',
  component: lazyRouteComponent(() =>
    import('@dashboard/pages/consultant-dashboard').then((m) => ({
      default: m.ConsultantDashboardPage,
    }))
  ),
  validateSearch: validateConsultantDashboardSearch,
});

export const consultantMoodboardRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'moodboard',
  component: lazyRouteComponent(() =>
    import('@dashboard/pages/consultant-dashboard').then((m) => ({
      default: m.ConsultantDashboardPage,
    }))
  ),
  validateSearch: validateConsultantDashboardSearch,
});

export const managementSalesGoalsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'management/sales-goals',
  component: lazyRouteComponent(() =>
    import('@dashboard/pages/sales-goals').then((m) => ({
      default: m.SalesGoalsPage,
    }))
  ),
  validateSearch: validateSalesGoalsSearch,
});
